export default {
    search_email: 'Email (as written on your ticket)',
    booking_number: 'Booking Number',
    find: 'Find Order',
    order_time: 'Order Time',
    total: 'Total',
    status: 'Status',
    contact_information: 'Contact Information',
    email: 'Email',
    given_name: 'First Name',
    family_name: 'Last Name',
    address_line_1: 'Address',
    postal_code: 'Postal Code',
    locality: 'City',
    country_code: 'Country',
    phone_number: 'Mobile Number',
    edit: 'Edit',
    update: 'Update',
    vehicles: 'Vehicles',
    read_term: 'I have read and accepted',
    term_change: 'Term of Change',
    send_order_email: 'Send booking email',
    send_order_email_desc: 'Resend the booking email to ',
    send_email: 'Send email',
    email_send_success: 'Email was send successfully',
    email_send_failed: 'Error send email',
    next_step: 'Next step',
    passengers: 'Passengers/vehicles',
    confirm_change: 'Confirm Change',
    change_success: 'Change was successfully.',
    change_failed: 'Error happened when changing',
    previous_step: 'Back',
    contact_information_desc: 'Here you can change contact information',
    vehicles_desc: 'Here you can change the make and model as well as the registration number',
    passengers_desc: 'Here you can reduce the number of passengers and/or vehicles',
    payment_amount: 'The amount you need to pay is ',
    payment_desc: 'Reduction of travellers for this ticket is now changed from a group ticket with a 50% discount to a regular ticket with a 25% discount. This means that extra payment must be made to cover the price change from a 50% discount to a 25% discount.',
    currency_nok : 'NOK',
    error_change_time_passed: 'Order change time have passed.',
    error_booking_number: 'Booking number is required',
    error_email: 'Email is required',
    error_order_not_found: 'We could not find a ticket for the information provided, check the ticket number and/or email address if it is written correctly, and try again.',
    error_agree_term: 'You have not agreed terms for change ticket',
    error_passenger_quantity_exceeded: 'The amount Passengers / vehicles can not exceed the amount of existing order.',
    error_passenger_quantity_not_changed: 'There are no changes of passengers / vehicles'
}
